import React from 'react';
import { Category } from '@/interfaces';
import { Typography } from '@/components/common';
import Images from '@/const/images';
import Image from 'next/image';

interface Props {
	category: Partial<Category>;
}

interface Content {
	icon: string;
	description: string;
}

export const CardCaseType: React.FC<Props> = ({ category }) => {
	const dir: Partial<Record<Category, Content>> = {
		Securities: {
			icon: Images.securities,
			description:
				'Cases involving misleading statements, insider trading, or market manipulation that cause investors to lose money or confidence.',
		},
		Antitrust: {
			icon: Images.antitrust,
			description:
				'Cases addressing unfair business practices like price-fixing, monopolies, or collusion that limit competition or raise consumer costs.',
		},
		// 'Whistleblower': {
		//   icon: ,
		//   description: 'Yorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.',
		// },
		Commodities: {
			icon: Images.commodities,
			description:
				'Cases involving manipulation of commodity markets, such as oil, metals, or agriculture, that distort prices and harm investors.',
		},
		'Health Care': {
			icon: Images.health,
			description:
				'Cases related to fraudulent billing, insurance overcharges, or practices that inflate medical costs or limit fair access.',
		},
		'Consumer Protection': {
			icon: Images.consumer,
			description:
				'Cases covering false advertising, unfair contract terms, or defective products that mislead or harm everyday consumers.',
		},
		// 'Commercial': {
		//   icon: '',
		//   description: 'Yorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.',
		// },
		'Data Privacy': {
			icon: Images.data,
			description:
				'Cases resulting from data breaches or misuse of personal information by companies that fail to safeguard user data.',
		},
	};

	const description = dir[category]?.description;
	const image = dir[category]?.icon ?? '';

	return (
		<div className="bg-white rounded-[20px] py-10 px-8 h-full">
			<Image src={image} alt="" width={64} height={64} />
			<div className="mt-5">
				<Typography
					type="custom-p"
					className="font-semibold leading-[110%] text-2xl"
				>
					{category}
				</Typography>
				<Typography type="regular-16" className="mt-2">
					{description}
				</Typography>
			</div>
		</div>
	);
};
